import React, { useEffect, useState, useMemo } from "react";
import { getAllVediosWithout } from ".";
import { isAuthenticated } from "../../Auth/helper";
import Header from "../../User/helper/Header";
import LoggedInNavbar from "./loggedInNavbar";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import AOS from "aos";
import "aos/dist/aos.css";
import CircularProgress from "@mui/material/CircularProgress";
import LoginPrompt from "../../components/LoginPrompt";

const CAPTION_TABS = [
  {
    id: "hindi",
    label: "🇮🇳 Hindi Captioned",
    match: "Hindi",
    emptyMsg: "No Hindi captioned videos available yet.",
  },
  {
    id: "english",
    label: "🌐 English Captioned",
    match: "English",
    emptyMsg: "No English captioned videos available yet.",
  },
  {
    id: "all",
    label: "All Videos",
    match: null,
    emptyMsg: "No videos available at the moment.",
  },
];

const UserPlay = () => {
  const navigate = useNavigate();
  const [products, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPrompt, setShowPrompt] = useState(false);
  const [activeTab, setActiveTab] = useState("hindi");

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const fetchdata = async () => {
      setLoading(true);
      try {
        const x = await getAllVediosWithout();
        setAllProducts(x);
      } catch (e) {
        console.error("Failed to fetch videos:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchdata();
  }, []);

  const { mainCat, catThumbNail } = useMemo(() => {
    const tab = CAPTION_TABS.find((t) => t.id === activeTab);
    const filtered = tab?.match
      ? products.filter((item) => item.captionType === tab.match)
      : products;

    const subCats = filtered.map((item) => item.subCategoryId);
    const unique = [
      ...new Map(subCats.map((item) => [item?.subCategoryName, item])).values(),
    ].filter(Boolean);

    return {
      mainCat: unique.map((item) => item.subCategoryName),
      catThumbNail: unique.map((item) => item.subCategoryImageCDN),
    };
  }, [products, activeTab]);

  const currentTab = CAPTION_TABS.find((t) => t.id === activeTab);

  const requireAuth = (then) => {
    const auth = isAuthenticated();
    if (auth?.token && auth?.user?._id) then();
    else setShowPrompt(true);
  };

  const showCategory = (subCatName) => {
    requireAuth(() => {
      // ── KEY FIX ───────────────────────────────────────────────────────────
      // Pass captionType as a query param so CategoryFilter can further filter
      // to only show videos with this caption label inside that subCategory.
      // "all" tab sends no captionType — CategoryFilter shows everything.
      const tab = CAPTION_TABS.find((t) => t.id === activeTab);
      const captionParam = tab?.match ? `?captionType=${tab.match}` : "";
      navigate(`/category/Videos/${subCatName}${captionParam}`);
    });
  };

  return (
    <div>
      <LoginPrompt show={showPrompt} onClose={() => setShowPrompt(false)} />

      {isAuthenticated()?.user?._id && isAuthenticated()?.token ? (
        <LoggedInNavbar />
      ) : (
        <Header />
      )}

      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px" }}>
        <div className="container-fluid" style={{ paddingTop: "80px" }}>
          <h2
            style={{
              color: "#E34607",
              lineHeight: "34px",
              padding: "20px 20px 8px",
            }}
          >
            Videos
          </h2>

          {/* ── Language tabs ─────────────────────────────────────────────── */}
          <div
            style={{
              display: "flex",
              gap: 8,
              padding: "0 20px 20px",
              flexWrap: "wrap",
            }}
          >
            {CAPTION_TABS.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  style={{
                    padding: "9px 20px",
                    borderRadius: 24,
                    border: isActive ? "none" : "1.5px solid #E34607",
                    background: isActive ? "#E34607" : "#fff",
                    color: isActive ? "#fff" : "#E34607",
                    fontWeight: 600,
                    fontSize: 14,
                    cursor: "pointer",
                    transition: "all 0.2s",
                    boxShadow: isActive
                      ? "0 3px 10px rgba(227,70,7,0.35)"
                      : "none",
                  }}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>

          {/* ── Content area ──────────────────────────────────────────────── */}
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 200,
              }}
            >
              <CircularProgress color="warning" />
            </div>
          ) : mainCat.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "60px 20px",
                color: "#888",
              }}
            >
              <i
                className="fas fa-film"
                style={{
                  fontSize: 36,
                  color: "#E34607",
                  opacity: 0.4,
                  marginBottom: 16,
                  display: "block",
                }}
              />
              <p style={{ fontSize: 16 }}>{currentTab?.emptyMsg}</p>
              {activeTab !== "all" && (
                <p style={{ fontSize: 13, color: "#aaa", marginTop: 6 }}>
                  Switch to "All Videos" to see everything, or check back later.
                </p>
              )}
            </div>
          ) : (
            <>
              <div className="d-flex flex-row flex-nowrap overflow-auto category-scroll">
                {mainCat.map((item, index) => (
                  <div className="col-sm-3" key={item}>
                    <center>
                      <div
                        className="card"
                        onClick={() => showCategory(item)}
                        style={{ width: "18rem", cursor: "pointer" }}
                      >
                        <div className="card-body">
                          <h5
                            className="card-title"
                            style={{ color: "#E34607" }}
                          >
                            {item}
                          </h5>
                          <LazyLoadImage
                            src={catThumbNail[index]}
                            alt={item}
                            height="200"
                            width="200"
                            effect="blur"
                          />
                        </div>
                      </div>
                    </center>
                  </div>
                ))}
              </div>

              <br />

              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  color: "#666",
                }}
              >
                <i
                  className="fas fa-hand-pointer"
                  style={{
                    fontSize: "24px",
                    color: "#E34607",
                    marginBottom: "15px",
                  }}
                ></i>
                <h4 style={{ color: "#E34607", marginBottom: "8px" }}>
                  Select a Category Above
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.5" }}>
                  Choose from the available video categories to view content
                  from that collection.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(UserPlay);
